@if (article()) {
<header class="article-head">
  <div
    class="article-head__background article-head__background--desktop"
    [style.background-image]="'url(' + article()?.image?.variants?.desktopHero?.url + ')'"
  ></div>

  <div
    class="article-head__background article-head__background--mobile"
    [style.background-image]="'url(' + article()?.image?.variants?.mobileHero?.url + ')'"
  ></div>

  <div class="article-head__overlay"></div>

  <div class="article-head__tintbar"></div>

  <div class="article-head__content">
    <div class="article-head__text">
      <h1 class="article-head__title">
        {{ article()?.title }}
      </h1>

      <time
        class="article-head__date"
        *ngIf="article()?.published_at"
        [dateTime]="article()?.published_at"
      >
        {{ article()?.published_at | date: 'yyyy-MM-dd | HH:mm' }}
      </time>
    </div>

    <figure class="article-head__image" *ngIf="article()?.image">
      <img
        [src]="article()?.image?.variants?.desktopHero?.url"
        [alt]="article()?.title"
        class="article-head__img article-head__img--desktop"
      />

      <img
        [src]="article()?.image?.variants?.mobileHero?.url"
        [alt]="article()?.title"
        class="article-head__img article-head__img--mobile"
      />
    </figure>
  </div>
</header>

<div class="article-body">
  <div class="article-body__components">
    @if (article()?.header; as header) {
    <p class="teaser">
      {{ header }}
    </p>
    } @for (component of sortedComponents(); track component.id) {
    <app-umpire-component-client [component]="component"> </app-umpire-component-client>
    }
    <div class="copyright">
      <hr />
      <span class="author-name">
        {{ article()?.author }}
      </span>
    </div>
  </div>
</div>
} @else {
<header class="article-head article-head">
  <div
    class="article-head__background article-head__background--desktop article-head__background--skeleton"
  ></div>

  <div
    class="article-head__background article-head__background--mobile article-head__background--skeleton"
  ></div>

  <div class="article-head__overlay"></div>

  <div class="article-head__tintbar"></div>

  <div class="article-head__content">
    <div class="article-head__text">
      <h1 class="article-head__title article-head__title--skeleton"></h1>

      <time class="article-head__date article-head__date--skeleton"> </time>
    </div>

    <figure class="article-head__image">
      <div
        class="article-head__img article-head__img--desktop article-head__img--skeleton"
      ></div>

      <div
        class="article-head__img article-head__img--mobile article-head__img--skeleton"
      ></div>
    </figure>
  </div>
</header>

<div class="article-body article-body--skeleton">
  <div class="article-body__components">
    <div class="teaser">
      <div class="teaser--skeleton"></div>
    </div>

    <div class="article-paragraph-skeleton">
      <div></div>
    </div>

    <div class="copyright">
      <hr />
      <span class="author-name author-name--skeleton"> </span>
    </div>
  </div>
</div>
}
